/**
 * Created by csaba.adam on 2017. 07. 18..
 */
import angular from 'angular';
import { RealEstateRelatedComponent } from './real-estate-related.component';
import favourite from './../../favourites/service/favourites-service.module';

const MODULE_NAME = 'RealEstateRelated';

export default angular.module(MODULE_NAME, [favourite]).component('realEstateRelated', RealEstateRelatedComponent).name;


